var settings = {
  debug: true,
  api: {
    protocol: 'https',
    host: 'api.staging.worldwidewomen.co',
    port: 443,
    base: 'api/v1'
  }
}

settings.api.url = `${settings.api.protocol}://${settings.api.host}:${settings.api.port}/${settings.api.base}/`

settings.facebook = {
  appId: '1444959322215000'
}

settings.GA = {
  code: 'UA-83921030-1'
}

settings.recaptcha = {
  key: '6Lf4SyETAAAAAMIficsFZQsggLe0ZLxx0ja1iGbm',
  secret: '6Lf4SyETAAAAAHrWSi3C3vRHUrcNHbApjUR3434L'
}

settings.raven = {
  "dsn" : 'https://090da9ea0de54e4f98c47844081239c1@sentry.io/129707',
  config: {}
}

settings.paypalenv = {
  env: 'sandbox'
}

settings.paypalclient = {
  PAYPAL_CLIENT_ID_SANDBOX: 'AUQ99j4Y_h3fH8PzYc07jIy9hgI8SExjWx8wxP8p3qQpSiApasACWvjlf82f-3nzxQdw2dcCLqcWh0JW'
}

module.exports = settings



// WEBPACK FOOTER //
// ./src/settings/staging.js